import { render, staticRenderFns } from "./SyllabusesListFilters.vue?vue&type=template&id=bccdd16c&scoped=true&"
import script from "./SyllabusesListFilters.vue?vue&type=script&lang=js&"
export * from "./SyllabusesListFilters.vue?vue&type=script&lang=js&"
import style0 from "./SyllabusesListFilters.vue?vue&type=style&index=0&id=bccdd16c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccdd16c",
  null
  
)

export default component.exports